/**
 * Per-campaign "tidy-managed" marker.
 *
 * ELK derives the layout from measured card dimensions, and those legitimately change
 * between sessions (nested-campaign progress, status chrome, edited titles). A board the
 * user only ever arranges via Tidy should silently follow the fresh ELK layout when that
 * happens — but a hand-arranged board must never be pulled back to auto. Saved coordinates
 * alone can't distinguish the two once dimension changes shift rows beyond a small epsilon,
 * so we remember the user's last intent explicitly:
 *
 * - set on full Tidy and on silent snap-to-ELK persists
 * - cleared when the user manually drags a card, reorders chains (< >), or runs a partial (selection) tidy
 *
 * Stored in localStorage: survives reopen on this device; on a device without the marker
 * the conservative small-epsilon snap still applies.
 */

const KEY_PREFIX = 'fokus-flow-tidy-managed:';

function keyFor(campaignId) {
  return `${KEY_PREFIX}${campaignId}`;
}

export function markCampaignTidyManaged(campaignId) {
  if (!campaignId) return;
  try {
    localStorage.setItem(keyFor(campaignId), '1');
  } catch {
    /* storage unavailable — degrade to conservative snap behavior */
  }
}

export function clearCampaignTidyManaged(campaignId) {
  if (!campaignId) return;
  try {
    localStorage.removeItem(keyFor(campaignId));
  } catch {
    /* ignore */
  }
}

export function isCampaignTidyManaged(campaignId) {
  if (!campaignId) return false;
  try {
    return localStorage.getItem(keyFor(campaignId)) === '1';
  } catch {
    return false;
  }
}
